import React from 'react';
import PropTypes from 'prop-types';

import { Subtitle, Container, Text } from './style';

const Name = ({ original }) => {
  const paxs = original.paxs.length;
  const { name, surname } = original.order.customer;

  return (
    <Container>
      <Text>{`${name || ''} ${surname || ''}`}</Text>
      <Subtitle>{`${paxs} Passengers - ${original.bags} Bags`}</Subtitle>
    </Container>
  );
};

Name.propTypes = {
  classes : PropTypes.shape({}).isRequired,
  original: PropTypes.shape({}),
};

Name.defaultProps = {
  original: {},
};

export default Name;
